import delve from 'dlv'

export function getBlock(blocks: any[], componentType: string): any {
  return blocks.find((b) => delve(b, '__component') === componentType)
}

export function getMediaUrl(media: any) {
  return delve(media, 'data.attributes.url')
}

export function getMediaAlt(media: any) {
  return delve(media, 'data.attributes.alternativeText')
}
